import Vue from 'vue'
import VueRouter from 'vue-router'
import { userCredential } from '@/global'

import Home from '@/components/home/Home'
import Auth from '@/components/auth/Auth'
import Reset from '@/components/reset/Reset'
//import Register from '@/components/register/Register'
import Nfses from '@/components/nfse/Nfses'
import Produtos from '@/components/produto/Produtos'
import Usuarios from '@/components/usuario/Usuarios'
import Empresas from '@/components/empresa/Empresas'
import Integracoes from '@/components/integracao/Integracoes'
import Planos from '@/components/plano/Planos'
import ImportNfse from '@/components/importacao/ImportNfse'
import Faturamentos from '@/components/faturamento/Faturamentos'
import Clientes from '@/components/cliente/Clientes'

Vue.use(VueRouter)

const routes = [{
    name: 'home',
    path: '/',
    component: Home
}, {
    name: 'auth',
    path: '/auth',
    component: Auth
}, {
    name: 'reset',
    path: '/reset',
    component: Reset
//}, {
//    name: 'register',
//    path: '/register',
//    component: Register
}, {
    name: 'nfse',
    path: '/nfse',
    component: Nfses,
    meta: { requiresAdmin: true }
}, {
    name: 'produto',
    path: '/produto',
    component: Produtos,
    meta: { requiresAdmin: true }
}, {
    name: 'usuario',
    path: '/usuario',
    component: Usuarios,
    meta: { requiresAdmin: true }
}, {
    name: 'empresa',
    path: '/empresa',
    component: Empresas,
    meta: { requiresAdmin: true }
}, {
    name: 'integracao',
    path: '/integracao',
    component: Integracoes,
    meta: { requiresAdmin: true }
}
, {
    name: 'plano',
    path: '/plano',
    component: Planos,
    meta: { requiresAdmin: true }
}, {
    name: 'importacao',
    path: '/importacao',
    component: ImportNfse,
    meta: { requiresAdmin: true }
}
, {
    name: 'faturamento',
    path: '/faturamento',
    component: Faturamentos,
    meta: { requiresAdmin: true }
}, {
    name: 'cliente',
    path: '/cliente',
    component: Clientes,
    meta: { requiresAdmin: true }
}
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(userCredential)
   
    // Valida se usuário é admin pra não permitir navegar nas paginas não autorizadas
    if (to.matched.some(record => record.meta.requiresAdmin)) {
        const user = JSON.parse(json) 
        // Nfse
        if (to.name === 'nfse') {
            user && user.nfse_vis ? next() : next({ path: '/'})
        } else 
        // Produto
        if (to.name === 'produto') {
            user && user.pro_vis ? next() : next({ path: '/'})
        } else 
        // Empresa
        if (to.name === 'empresa') {
            user && user.emp_vis ? next() : next({ path: '/'})
        } else 
        // Integração
        if (to.name === 'integracao') {
            user && user.int_vis ? next() : next({ path: '/'})
        } else 
        // Usuario
        if (to.name === 'usuario') {
            user && user.admin ? next() : next({ path: '/'})
        } else 
        // Plano
        if (to.name === 'plano') {
            user && user.pla_vis ? next() : next({ path: '/'})
        } else 
        // Importacao
        if (to.name === 'importacao') {
            user && user.imp_vis ? next() : next({ path: '/'})
        }
        // Faturamento
        if (to.name === 'faturamento') {
            user && user.fat_vis ? next() : next({ path: '/'})
        } else 
        // Cliente
        if (to.name === 'cliente') {
            user && user.cli_vis ? next() : next({ path: '/'})
        } 
    } else {
        next()
    }

})

export default router